module.exports = {"TXTCLI_Code":{"id":"TXTCLI_Code","defaultMessage":"Kod","track":"Code"}}